"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _Image = _interopRequireDefault(require("../Image"));
var _SkeletonTypography = _interopRequireDefault(require("./SkeletonTypography"));
var _SkeletonImage = _interopRequireDefault(require("./SkeletonImage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SkeletonProvider = _ref => {
  let {
    children,
    show
  } = _ref;
  if (!show) {
    return children;
  }
  const mapChild = child => {
    if (!child) {
      return null;
    }
    let childElement = child;
    if (childElement.props && 'children' in childElement.props) {
      const {
        children: elementChildren
      } = childElement.props;
      const mappedChildren = Array.isArray(elementChildren) ? elementChildren.map(mapChild) : mapChild(elementChildren);
      childElement = /*#__PURE__*/_react.default.cloneElement(childElement, {
        children: mappedChildren
      });
    }
    if (childElement.type === _componentsBase.Typography) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonTypography.default, {
        ...childElement.props.skeleton,
        show: show,
        children: childElement
      });
    }
    if (childElement.type === _Image.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonImage.default, {
        ...childElement.props.skeleton,
        imgHeight: childElement.props.height,
        rounded: childElement.props.rounded,
        show: show,
        children: childElement
      });
    }
    return childElement;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: _react.default.Children.map(children, mapChild)
  });
};
SkeletonProvider.propTypes = {
  show: _propTypes.default.bool.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired
};
var _default = exports.default = SkeletonProvider;